import {Avatar, Spin} from 'antd'
import {organization_getAnnouncementById_Api} from 'apis'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import useRouter from "../../../modules/navigation/useRouter";
import useAsync from "../../../modules/asyncCache/useAsync";
import {useSelectEntities} from "../../../redux/entities/useSelectEntities";
import ContentLayout from "../../../components/layouts/Default/ContentLayout";
import {HeaderButton} from "../../Organization/components/PageHeader";
import {SettingOutlined} from "@ant-design/icons";
import {callNativeShare, createFacebookShareLink, createTwitterShareLink} from "../../../helpers";
import getLinkToDetail, {getAbsoluteLinkToDetail} from "../../../helpers/getLinkToDetail";
import {RiFacebookFill, RiShareForwardFill, RiTwitterXLine} from "react-icons/ri";
import getTitle from "../../../helpers/getTitle";
import {ProductAdsContainer} from "../../AppLocals/Shop/components/ProductAds";
import _ from "lodash";
import {FeedMoreRecommends} from "../FeedMoreRecommends";
import preventParentEvent from "../../../helpers/preventParentEvent";
import classNames from "classnames";
import {Link} from "react-router-dom";
import {OrganizationAnnouncementItem} from "../../Organization/components/OrganizationAnnouncementItem";
import {Responses} from "../Responses";
import {getId, getType} from "../../../apis/model/base";
import {organizationAnnouncementSchema} from "../../../apis/schema";
import {formatRelativeTime} from "../../../helpers/dateUtils";
import {FollowButton} from "../../../components/Feed/FollowButton";
import {BiSolidChurch} from "react-icons/bi";
import FlyWrapper from "../../AppLocals/Templates/FlyWrapper";
import {headerHeight} from "../../AppLocals/configs";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {FeedProvider} from "../../../components/Feed/FeedProvider";
import {allActions} from "../../../components/Feed/TimeLineFeed";
import FeedContext from "../../../components/Feed/FeedContext";
import {Vote} from "../../../components/Feed/Vote";
import {Share} from "../../../components/Feed/Share";
import {SelectEntityItem} from "../../../components/SelectEntityItem";
import {PiShareFat} from "react-icons/pi";

const OrganizationAnnouncementPageContent = ({id}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {handleGoBack, history} = useRouter()

    const {isLoading, success, errorMessages, ...rest} = useAsync({
        apiInfo: organization_getAnnouncementById_Api,
        query: {
            ':id': id,
        },
    })

    const item = useSelectEntities(id, organizationAnnouncementSchema, {})

    return (
        <ContentLayout
            title={t('announcements')}
            renderMenu={NullAsDefault}
            extra={
                item && (
                    <>
                        {item.edit && (
                            <HeaderButton onClick={() => history.push(`/article/${id}/edit`)}>
                                <SettingOutlined
                                    style={{
                                        fontSize: '1.4em',
                                    }}
                                />
                            </HeaderButton>
                        )}
                        <div className="flex gap-2 mr-2">
                            <HeaderButton
                                component="a"
                                href={createFacebookShareLink(getAbsoluteLinkToDetail(item))}
                                target="_blank"
                                width={22}
                                height={22}
                                icon={<RiFacebookFill size={12}/>}
                            />
                            <HeaderButton
                                component="a"
                                href={createTwitterShareLink(getAbsoluteLinkToDetail(item))}
                                target="_blank"
                                width={22}
                                height={22}
                                icon={<RiTwitterXLine size={10}/>}
                            />
                            <HeaderButton
                                onClick={() => {
                                    callNativeShare({
                                        title: getTitle(item),
                                        url: getAbsoluteLinkToDetail(item),
                                    })
                                }}
                                width={22}
                                height={22}
                                icon={<RiShareForwardFill size={12}/>}
                            />
                        </div>
                    </>
                )
            }
            right={NullAsDefault}
            renderRight={NullAsDefault}
            onCancel={handleGoBack}>

            <div className="w-full mt-2 max-w-6xl mx-auto flex flex-col lg:flex-row gap-3 md:gap-6 p-3">
                <div className="flex-1">
                    <Spin spinning={isLoading}>
                        <div
                            onContextMenu={
                                item.content_disabled ? preventParentEvent : undefined
                            }
                            className={classNames(
                                'w-full mx-auto flex', item.content_disabled && 'content_disabled'
                            )}>
                            <div className="mb-6 w-full flex flex-col gap-3">
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={36}
                                        src={_.get(item?.organization, 'avatar')}
                                        icon={<BiSolidChurch size={16} className="text-primary-500"/>}
                                        className="flex flex-center bg-primary-50 rounded-lg"
                                    />
                                    <div className="items-baseline space-x-1 leading-tight">
                                        <Link
                                            to={getLinkToDetail(item?.organization)}
                                            className="font-semibold text-primary-900 no-underline">
                                            {getTitle(item?.organization)}
                                        </Link>
                                        <span className="text-color-400 italic tracking-wider">
                                        <label style={{fontStyle: 'normal'}}
                                               className="mx-1 font-normal text-color-100">
                                            {formatRelativeTime(item?.created)}
                                        </label>
                                            {t('notified')}
                                    </span>
                                        <FollowButton
                                            renderLabel={(_item) => renderIf(
                                                !_item?.follow_status,
                                                <label className="cursor-pointer">{`\u2022 ${t('follow')}`}</label>
                                            )}
                                            item={item?.container}
                                        />
                                    </div>
                                </div>
                                <OrganizationAnnouncementItem item={item}/>
                            </div>
                        </div>
                        <div className="FeedCardFooterLine"/>
                        <SelectEntityItem
                            item={item?.id}
                            schema={organizationAnnouncementSchema}>
                            {(item) => (
                                <FeedProvider item={item} defaultActions={allActions}>
                                    <FeedContext.Consumer>
                                        {({handleClick, shareUrl}) => (
                                            <div className="px-0 md:px-2 flex items-center gap-1 justify-around gap-0 md:gap-3 FeedCardFooter">
                                                <Vote id={item?.id}/>
                                                <Share
                                                    url={item?.shareUrl}
                                                    component={
                                                        <div
                                                            style={{padding: isLg ? '4px 10px' : '4px'}}
                                                            className="flex items-center gap-1 md:gap-2 hover:background-200 rounded-md cursor-pointer">
                                                            <PiShareFat size={16} className="text-color-200"/>
                                                            <span className="text-xs md:text-sm text-color-300">
                                                                {t('share')}
                                                            </span>
                                                        </div>
                                                    }
                                                />
                                            </div>
                                        )}
                                    </FeedContext.Consumer>
                                </FeedProvider>
                            )}
                        </SelectEntityItem>
                        <div className="py-4 mx-auto mt-6 w-full verticalList p-3 flex flex-col">
                            <Responses
                                type={getType(item)}
                                id={getId(item)}
                            />
                        </div>
                    </Spin>
                </div>
                <LayoutContext.Consumer>
                    {({isLg}) => isLg && (
                        <div className="ant-col-7 space-y-6">
                            <FlyWrapper top={parseInt(headerHeight)}>
                                <ProductAdsContainer keyword={_.get(item, 'keywords', []).map(k => k.keyword).join(', ')}/>
                                {item && (
                                    <div className="flex flex-col gap-6 mx-3">
                                        {!_.isEmpty(_.get(item, 'others_in_container')) && (
                                            <div className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                                <div className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                                    <span className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                                        {t('related articles')}
                                                    </span>
                                                </div>
                                                <FeedMoreRecommends
                                                    item={item.container}
                                                    list={item.others_in_container}
                                                />
                                            </div>
                                        )}
                                        {!_.isEmpty(_.get(item, 'others_in_creator')) && (
                                            <div className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                                <div className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                                    <span className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                                        {t('from the sender')}
                                                    </span>
                                                </div>
                                                <FeedMoreRecommends
                                                    item={item.creator}
                                                    list={item.others_in_creator}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </FlyWrapper>
                        </div>
                    )}
                </LayoutContext.Consumer>
            </div>
        </ContentLayout>
    )
}

export default OrganizationAnnouncementPageContent
